import PropTypes from 'prop-types';
import authService, { privileges } from '../../services/AuthService';

const CanCreate = ({ on = null, children = null, fallback = null }) => {
  if (!children) return null;
  if (on) {
    if (
      !authService.hasPermission({
        functionality: on,
        privilege: privileges.Create,
      })
    )
      return fallback;
  }

  return children;
};

CanCreate.propTypes = {
  on: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  ]),
  children: PropTypes.node,
  fallback: PropTypes.node,
};
export default CanCreate;
